import Address from "../../Models/Address";

export const GET_ADDRESSES = "Address/getAddresses";
export const DELETE_ADDRESS = "Address/deleteAddress";
export const SAVE_ADDRESS = "Address/saveAddress";

export interface AddressReducerType {
  addresses: Address[],
}

export interface ISearchAddressParams {
  customer?: string;
}
